import store from '@/cache/store';

export const routes = [
  {
    path: '/',
    name: 'sign-in',
    component: () => import('../views/util/sign_in.vue')
  },
  {
    path: '/sign-out',
    name: 'sign-out'
  },
  {
    path: '/sign-up',
    name: 'sign-up',
    component: () => import('../views/util/sign_up.vue')
  },
  {
    path: '/home',
    name: 'home',
    meta: { requiresAuth: true },
    beforeEnter: (to, from, next) => {
      store
        .dispatch('getAllServices', {})
        .then(() => next())
        .catch(error => console.log(error));
    },
    component: () => import('../views/home.vue')
  },
  {
    path: '/service-detail',
    name: 'service-detail',
    meta: { requiresAuth: true },
    props: true,
    beforeEnter: (to, from, next) => {
      store
        .dispatch('getAllServices', {})
        .then(() => next())
        .catch(error => console.log(error));
    },
    component: () => import('../views/service_detail.vue')
  },
  {
    path: '/profile',
    name: 'profile',
    meta: { requiresAuth: true },
    component: () => import('../views/profile.vue')
  },
  {
    path: '/guide',
    name: 'guide',
    component: () => import('../views/guide.vue')
  },
  {
    path: '/buffer',
    name: 'buffer',
    meta: { requiresAuth: true },
    component: () => import('../views/util/buffer.vue')
  },
  {
    path: '/setup',
    name: 'setup',
    meta: { requiresAuth: true },
    component: () => import('../views/setup.vue')
  },
  {
    path: '/customer-service',
    name: 'customer-service',
    meta: { requiresAuth: true },
    component: () => import('../views/customer_service.vue')
  },
  {
    path: '/events',
    name: 'events',
    meta: { requiresAuth: true },
    beforeEnter: (to, from, next) => {
      store
        .dispatch('getEvents', {})
        .then(() => next())
        .catch(error => console.log(error));
    },
    component: () => import('../views/events.vue')
  },
  {
    path: '/event-details',
    name: 'event-details',
    meta: { requiresAuth: true },
    props: true,
    beforeEnter: (to, from, next) => {
      store
        .dispatch('getAllServices', {})
        .then(() => next())
        .catch(error => console.log(error));
    },
    component: () => import('../views/event_details.vue')
  },
  {
    path: '/event-requests',
    name: 'event-requests',
    meta: { requiresAuth: true },
    props: true,
    component: () => import('../views/event_requests.vue')
  },
  {
    path: '/create-event',
    name: 'create-event',
    meta: { requiresAuth: true },
    props: true,
    beforeEnter: (to, from, next) => {
      store
        .dispatch('getAllServices', {})
        .then(() => next())
        .catch(error => console.log(error));
    },
    component: () => import('../views/create_event.vue')
  },
  {
    path: '/shopping-cart',
    name: 'shopping-cart',
    meta: { requiresAuth: true },
    props: true,
    beforeEnter: (to, from, next) => {
      store
        .dispatch('getAllServices', {})
        .then(() => next())
        .catch(error => console.log(error));
    },
    component: () => import('../views/shopping_cart.vue')
  },
  {
    path: '/settings',
    name: 'settings',
    meta: { requiresAuth: true },
    component: () => import('../views/util/settings.vue')
  },
  {
    path: '/admin',
    meta: { requiresAuth: true },
    component: () => import('../views/admin/index.vue'),
    children: [
      {
        path: '',
        name: 'admin-home',
        meta: { requiresAuth: true },
        component: () => import('../views/admin/home.vue')
      },
      {
        path: 'beta-users',
        name: 'beta-users',
        meta: { requiresAuth: true },
        component: () => import('../views/admin/beta_users.vue')
      },
      {
        path: 'user-profiles',
        name: 'user-profiles',
        meta: { requiresAuth: true },
        component: () => import('../views/admin/user_profiles.vue')
      },
      {
        path: 'user-events',
        name: 'user-events',
        meta: { requiresAuth: true },
        beforeEnter: (to, from, next) => {
          store
            .dispatch('getAllUserEvents', {})
            .then(() => next())
            .catch(error => console.log(error));
        },
        component: () => import('../views/admin/user_events.vue')
      },
      {
        path: 'user-detail',
        name: 'admin-user-detail',
        meta: { requiresAuth: true },
        props: true,
        component: () => import('../views/admin/user_detail.vue')
      },
      {
        path: 'event-detail',
        name: 'admin-event-detail',
        meta: { requiresAuth: true },
        props: true,
        beforeEnter: (to, from, next) => {
          store
            .dispatch('getAllServices', {})
            .then(() => next())
            .catch(error => console.log(error));
        },
        component: () => import('../views/admin/event_detail.vue')
      },
      {
        path: 'marketing-campaigns',
        name: 'admin-marketing-campaigns',
        meta: { requiresAuth: true },
        beforeEnter: (to, from, next) => {
          store
            .dispatch('getUsers', {})
            .then(() => next())
            .catch(error => console.log(error));
        },
        component: () => import('../views/admin/marketing.vue')
      },
      {
        path: 'user-chat',
        name: 'admin-user-chat',
        meta: { requiresAuth: true },
        beforeEnter: (to, from, next) => {
          store
            .dispatch('getUsers', {})
            .then(() => next())
            .catch(error => console.log(error));
        },
        component: () => import('../views/admin/user_chats.vue')
      },
      {
        path: 'chat-detail',
        name: 'admin-chat-detail',
        meta: { requiresAuth: true },
        props: true,
        beforeEnter: (to, from, next) => {
          store
            .dispatch('getAllServices', {})
            .then(() => next())
            .catch(error => console.log(error));
        },
        component: () => import('../views/admin/chat_detail.vue')
      }
    ]
  }
];
